import {MiscApi} from "@/Stub/V1";
import {BaseApiConfig} from "@/Service/Api/V1/BaseApiConfig";

export const MiscApiClient = new MiscApi(BaseApiConfig);